import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DropdownMenu from './components/DropdownMenu';
import Home from './pages/Home';
import About from './pages/About';

function App() {
  return (
    <Router>
      <div>
        <DropdownMenu />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;